import React from "react";
import { connect } from 'react-redux'

import { tutorsActions } from '../actions';
 
import { Spinner } from 'components/Icons/Spinner';
import { Row, Col } from "reactstrap";
// import { Link } from 'react-router-dom';
import { CourseCard } from '../components/CourseCard'; 
import { CenterMessageCard } from 'components/CenterMessageCard';


var viewActions = require ('store/view.actions');


class TutorCourses extends React.Component {


  componentDidMount() {
    this.props.getTutorCourses(this.props.token,  this.props.currentCalendarID) ;
    // this.props.getTeacherCourses (this.props.token,  this.props.user.persona_id , this.props.currentCalendarID) 
    this.props.setMainTitle("Mis cursos", [] )
  }

  constructor(props) {
    super(props);
    this.state = {
    }

 }

  render() {
    return (
      <>
        <div className="content">
         {!this.props.view.loadingModules.getTutorCourses ?
          (this.props.tutorCourses && this.props.tutorCourses.length>0?
            <Row>
                {this.props.tutorCourses.map( (course) => {
                            return (
                                <Col md="4">
                                  <CourseCard
                                    token={this.props.token}
                                    course={course}
                                    calendarID={this.props.currentCalendarID}
                                    />
                                </Col>
                          )
                        } )
                        }
            </Row>
            :
                  <CenterMessageCard 
                      icon="fa-hand-paper-o"
                      title="Oooops 🤷‍♂️">
                        Aún no tienes cursos asignados. 
                  </CenterMessageCard> 
            )
        : 
        <Spinner size="XL" />
        }
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID:  state.school.currentCalendarID,
        view: state.view,
        user: state.auth.session.user,
        tutorCourses: state.tutors.tutorCourses,
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getTutorCourses: (token, calendarID) => {
          dispatch(tutorsActions.getTutorCourses(token, calendarID));
        } , 
         setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        
      
 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(TutorCourses);

